const en_master_goodsPrice = {

}

export default en_master_goodsPrice;